import React from "react";
import { Form } from "react-bootstrap";

// Shared field label that appends a red asterisk when the field is required.
export const RequiredLabel = ({ label, required, className }: { label: React.ReactNode; required?: boolean; className?: string }) => (
  <Form.Label className={className}>
    {label}
    {required && <span className="text-danger" aria-hidden="true"> *</span>}
  </Form.Label>
);
